import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: React.ReactNode;
}

export const Input: React.FC<InputProps> = ({ label, icon, className = '', ...props }) => {
  return (
    <div className="w-full">
      {label && <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">{label}</label>}
      <div className="relative">
        {icon && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-gray-500">
            {icon}
          </div>
        )}
        <input
          className={`w-full ${icon ? 'pl-11' : 'pl-4'} pr-4 py-3 border-0 rounded-2xl focus:outline-none focus:ring-2 focus:ring-warm-500 dark:focus:ring-dark-purple-300 transition-all bg-white dark:bg-dark-200 text-sm font-medium text-soft-black dark:text-gray-100 placeholder-soft-lightgray dark:placeholder-gray-500 shadow-soft focus:shadow-soft-lg ${className}`}
          {...props}
        />
      </div>
    </div>
  );
};
